import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useABNExtrasStore = defineStore('abnextrastore', () => {
  // Store Models
  const prev_abn                = ref("")
  const agricultural_property   = ref(false)
  const more_than_one_business  = ref(false)
  const why_applying            = ref("")
  const first_time              = ref(true)
  const do_bn                   = ref(false)
  const do_gst                  = ref(false)
  const gaddressConfirmationBox = ref(false)
  const do_cancel_abn           = ref(false)
  const do_cancel_gst           = ref(false)
  const do_cancel_bn            = ref(false)

  const why_applying_options = [
    'New Business in Australia',
    'Investment Purposes',
    'Purchased Existing Business',
    'Contractor/Sub-contractor',
    'To receive payment for services',
    'Change in Business Structure',
  ]

  const states = [
    "AUSTRALIAN CAPITAL TERRITORY",
    "NEW SOUTH WALES",
    "NORTHERN TERRITORY",
    "QUEENSLAND",
    "SOUTH AUSTRALIA",
    "TASMANIA",
    "VICTORIA",
    "WESTERN AUSTRALIA",
  ]

  const update = (order) => {
    prev_abn.value                = order.abn_extra_data?.prev_abn
    agricultural_property.value   = order.abn_extra_data?.agricultural_property
    more_than_one_business.value  = !!order.abn_extra_data?.more_than_one_business
    why_applying.value            = order.abn_extra_data?.why_applying
    first_time.value              = !!order.abn_extra_data?.first_time
    do_bn.value                   = !!order.business_name
    do_gst.value                  = !!order.gst
    do_cancel_abn.value           = !!order.abn_cancellation
    do_cancel_bn.value            = !!order.bn_cancellation
    do_cancel_gst.value           = !!order.gst_cancellation
  }

  const resetData = () => {
    prev_abn.value               = ''
    agricultural_property.value  = false
    more_than_one_business.value = false
    why_applying.value           = ''
    first_time.value             = true
    do_bn.value                  = false
    do_gst.value                 = false
    gaddressConfirmationBox.value = false
    do_cancel_abn.value          = false
    do_cancel_gst.value          = false
    do_cancel_bn.value           = false
  }

 const setCancelABN = (status) => {
    do_cancel_abn.value = status
  }

 const setCancelGST = (status) => {
  do_cancel_gst.value = status
 }

 const setCancelBN = (status) => {
  do_cancel_bn.value = status
 }

  return {
    prev_abn,
    agricultural_property,
    more_than_one_business,
    why_applying,
    first_time,
    why_applying_options,
    states,
    do_bn,
    do_gst,
    do_cancel_abn,
    do_cancel_bn,
    do_cancel_gst,
    update,
    resetData,
    setCancelABN,
    setCancelGST,
    setCancelBN
  }
},  { persist: true, })
